import { captureException } from './error';
import { getItemPrices } from './item';

export function triggerAnalyticEvent(event, ecommerce = null, params = {}) {
  (window.dataLayer || []).push({ ecommerce: null });
  (window.dataLayer || []).push({
    event,
    ...params,
    ecommerce,
  });
}

export function transformToAnalyticsItems({ items, merchant, coupon }) {
  try {
    return items.map((item, index) => {
      const { price, discountedPrice } = getItemPrices({ item });
      return {
        item_id: item.id,
        item_name: item.name || item.item_name,
        affiliation: merchant ? `${merchant.name} #${merchant.id}` : undefined,
        coupon,
        discount: discountedPrice ? price - discountedPrice : 0,
        index,
        item_variant: item?.selection?.size || 1,
        price,
        quantity: item?.selection?.qty || item.qty || 1,
      };
    });
  } catch (e) {
    captureException(e);
    return [];
  }
}
